import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
  CodeFacade,
  CodeService,
  LoginSettingsApiService,
  LoginSettingsFacade,
  ScimFacade,
  ScimService,
  UserFacadeService,
  UserService
} from './services';
import * as storeFeature from './store';
import { AbstractIdentityConfigService } from './services/abstract-identity-config/abstract-identity-config.service';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(storeFeature.featureKey, storeFeature.reducers),
    EffectsModule.forFeature([
      storeFeature.UserEffects,
      storeFeature.UserServerEventEffects,
      storeFeature.ScimEffects,
      storeFeature.LoginSettingsEffects,
      storeFeature.AlertEffects,
    ]),
  ],
})
export class IdentityModule {
  static forRoot(configuration: { configType: Type<AbstractIdentityConfigService> }): ModuleWithProviders<IdentityModule> {
    return {
      ngModule: IdentityModule,
      providers: [
        {
          provide: AbstractIdentityConfigService,
          useClass: configuration.configType
        },
        UserService,
        UserFacadeService,
        ScimService,
        ScimFacade,
        CodeFacade,
        CodeService,
        LoginSettingsApiService,
        LoginSettingsFacade
      ],
    };
  }
}
